// extracted by mini-css-extract-plugin
module.exports = {"container":"Section_container__LowMt","sidebar":"Section_sidebar__vUovT","main":"Section_main__MY0Mz","form":"Section_form__EFbur"};